import { Fragment, ReactNode, useCallback } from 'react';

import { AnyObject } from 'webclient.constants';
import FileDropperLoading from 'lib/form/file-dropper/file-dropper-loading';
import { ImagePreviewStaticActions } from './image-picker-static.style';
import { ImagePickerMode } from './image-picker.constants';
import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import {
  ImageStatic,
  ImageStaticWrapper,
} from 'approot/shared/images/images.style';
import { useImageLoad } from 'approot/shared/images/images.hooks';
import DeleteButtonIcon from 'approot/shared/styles/buttons/delete-icon-button';

type Props = {
  mode?: ImagePickerMode;
  value: AnyObject;
  url: string;
  label?: ReactNode;
  s3Key?: string;
  extraActions?: ReactNode;
  deleteImage: () => void;
  onChange: (cropValues: AnyObject) => void;
};

const ImagePreviewStatic = ({
  s3Key,
  value,
  onChange,
  deleteImage,
  label,
  url,
  extraActions,
}: Props) => {
  const { imageHasLoaded } = useImageLoad(url);

  const updateForm = useCallback(() => {
    const imageKey = value && value.key ? value.key : s3Key;

    const newValue = {
      key: imageKey,
    };

    onChange(newValue);
  }, [value, s3Key, onChange]);

  const onImageDownloaded = useCallback(() => {
    updateForm();
  }, [updateForm]);

  return (
    <Fragment>
      {label ? label : null}
      {!imageHasLoaded && <FileDropperLoading />}
      <ImageStaticWrapper $isLoading={!imageHasLoaded}>
        {imageHasLoaded && (
          <ImagePreviewStaticActions>
            {extraActions && extraActions}
            <TooltipWrapper hoverText="Remove image">
              <DeleteButtonIcon
                data-selector="delete-image"
                aria-label="Remove image"
                onClick={deleteImage}
              />
            </TooltipWrapper>
          </ImagePreviewStaticActions>
        )}

        <ImageStatic
          $imageHasLoaded={imageHasLoaded}
          src={url}
          onLoad={onImageDownloaded}
          alt=""
        />
      </ImageStaticWrapper>
    </Fragment>
  );
};

export default ImagePreviewStatic;
